export default __webpack_public_path__ + "static/media/product03.4e1d88fe.png";